(function () {
  const STORAGE_KEY = 'inkybox_recently_viewed_products_v1';
  const PRODUCT_IDS_STORAGE_KEY = 'inkybox_recently_viewed_product_ids_v1';
  const MAX_STORED_PRODUCTS = 12;

  function readHandles() {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string' && handle) : [];
    } catch (error) {
      return [];
    }
  }

  function writeHandles(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED_PRODUCTS)));
    } catch (error) {
      // Browsing history is optional when storage is unavailable or blocked.
    }
  }

  function readProductIds() {
    try {
      const value = JSON.parse(window.localStorage.getItem(PRODUCT_IDS_STORAGE_KEY) || '{}');
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    } catch (error) {
      return {};
    }
  }

  function writeProductIds(productIds) {
    try {
      window.localStorage.setItem(PRODUCT_IDS_STORAGE_KEY, JSON.stringify(productIds));
    } catch (error) {
      // Browsing history is optional when storage is unavailable or blocked.
    }
  }

  function recordCurrentProduct() {
    const product = document.querySelector('[data-recently-viewed-product-handle]');
    const handle = product?.dataset.recentlyViewedProductHandle;
    if (!handle) return;

    const handles = readHandles().filter((storedHandle) => storedHandle !== handle);
    handles.unshift(handle);
    writeHandles(handles);

    const productId = String(product.dataset.productId || '');
    if (productId) {
      const productIds = readProductIds();
      const retainedHandles = new Set(handles.slice(0, MAX_STORED_PRODUCTS));
      Object.keys(productIds).forEach((storedHandle) => {
        if (!retainedHandles.has(storedHandle)) delete productIds[storedHandle];
      });
      productIds[handle] = productId;
      writeProductIds(productIds);
    }
  }

  async function resolveProductIds({ exclude = [], limit = 2 } = {}) {
    const excluded = new Set(exclude.map(String));
    const handles = readHandles();
    const productIds = readProductIds();
    const resolved = [];
    let changed = false;

    for (const handle of handles) {
      let productId = String(productIds[handle] || '');
      if (!productId) {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (response.ok) {
            const product = await response.json();
            productId = String(product?.id || '');
            if (productId) {
              productIds[handle] = productId;
              changed = true;
            }
          }
        } catch (error) {
          // Ignore stale or unavailable history entries.
        }
      }
      if (!productId || excluded.has(productId) || resolved.includes(productId)) continue;
      resolved.push(productId);
      if (resolved.length >= limit) break;
    }

    if (changed) writeProductIds(productIds);
    return resolved;
  }

  window.InkyboxRecentlyViewed = { readHandles, resolveProductIds };

  async function fetchCard(handle) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}products/${encodeURIComponent(handle)}?view=recently-viewed`, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    if (!response.ok) return null;

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    return documentFragment.querySelector('[data-recently-viewed-card]');
  }

  async function loadSection(section) {
    if (section.dataset.recentlyViewedLoaded === 'true') return;
    section.dataset.recentlyViewedLoaded = 'true';

    const grid = section.querySelector('[data-recently-viewed-grid]');
    const emptyState = section.querySelector('[data-recently-viewed-empty]');
    const limit = Number(section.dataset.productsToShow) || 4;
    const handles = readHandles().slice(0, limit);

    if (!grid || !handles.length) {
      if (window.Shopify?.designMode) {
        section.hidden = false;
        if (emptyState) emptyState.hidden = false;
      }
      return;
    }

    const cards = await Promise.all(handles.map((handle) => fetchCard(handle).catch(() => null)));
    const validCards = cards.filter(Boolean);

    if (!validCards.length) {
      if (window.Shopify?.designMode) {
        section.hidden = false;
        if (emptyState) emptyState.hidden = false;
      }
      return;
    }

    validCards.forEach((card, index) => {
      card.id = `Slide-${section.dataset.sectionId}-${index + 1}`;
      grid.appendChild(card);
    });

    section.hidden = false;
    window.initInkyboxCardPreview?.(section);
  }

  function initRecentlyViewed(scope) {
    scope.querySelectorAll('[data-recently-viewed-products]').forEach((section) => {
      loadSection(section);
    });
  }

  function init() {
    recordCurrentProduct();
    initRecentlyViewed(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => initRecentlyViewed(event.target));

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    document.querySelectorAll('[data-recently-viewed-products]').forEach((section) => {
      section.querySelector('[data-recently-viewed-grid]')?.replaceChildren();
      section.dataset.recentlyViewedLoaded = 'false';
      section.hidden = true;
      loadSection(section);
    });
  });
})();
